/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import {
	AppBar,
	Toolbar,
	Box,
	Hidden,
	useScrollTrigger,
	Collapse,
	withWidth
} from '@material-ui/core';
import { DateRange } from '@material-ui/icons';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import Constants from '../../../common/Constants';
import SignUp from '../../signup/layout/SignUp';
import HeaderLogo from '../components/HeaderLogo';
import HeaderMenu from '../components/HeaderMenu';
import HeaderSearchBox from '../components/HeaderSearchBox';
import SideDrawer from '../components/SideDrawer';
import AjaxHelper from '../../../common/AjaxHelper';
import FilterMain from '../../search/components/filters/FilterMain';
import DateRangeSelector from '../../DateRangeSelector';

function DefaultHeader(props) {
	const [headerProps, setHeaderProps] = useState(null);
	const {
		width,
		layout,
		updateProducts,
		pageActiveCallback,
		searchComponents,
		searchParams
	} = props;
	const { calendar } = (
		searchComponents && searchComponents.otherSettings && searchComponents.otherSettings.filter
	) || {};
	const theme = useTheme();
	const useStyles = makeStyles({
		selector: {
			display: 'flex',
			alignItems: 'center',
			marginLeft: '10px',
			borderBottom: '1px solid #949494',
			'&:hover': {
				borderBottom: '2px solid black',
			},
			'&:focus-within': {
				borderBottom: `2px solid ${theme.palette.primary.main}`,
			}
		},
		icons: {
			fill: theme.palette.primary.main,
			margin: '0px 7px 3px 5px',
			fontSize: '20px'
		}
	});
	const classes = useStyles();

	const trigger = useScrollTrigger({
		disableHysteresis: true,
		threshold: (window.location.pathname === '/' || window.location.pathname === '/search')
		&& width !== 'xs'
			? 0
			: document.body.scrollHeight
	});

	function HideOnScroll(props) {
		const { children } = props;
		return (
			<Collapse in={
				!trigger
				|| (headerProps
				&& headerProps.otherSettings
				&& headerProps.otherSettings.header
				&& headerProps.otherSettings.header.header_position === 'fixed')
			}
			>
				{children}
			</Collapse>
		);
	}

	useEffect(() => {
		let isMounted = true;
		(async () => {
			const headerScreenDesign = await AjaxHelper
				.invokeServerAPIPromise('/api/screenDesign', { screenName: Constants.SCREEN_NAMES[6] });
			if (isMounted) setHeaderProps(headerScreenDesign);
		})();
		return () => { isMounted = false; };
	}, []);

	const navbar = (
		<Toolbar style={{
			padding: width !== 'xs'
				? '5px 40px'
				: '5px 20px',
			boxShadow: trigger
			|| (width !== 'xs'
			&& layout !== 'sidebar'
			&& (window.location.pathname === '/' || window.location.pathname === '/search'))
				? '0 1px 0px rgba(57, 63, 72, 0.1)'
				: '0 3px 5px rgba(57, 63, 72, 0.3)',
			height: '70px'
		}}
		>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="flex-start"
				flexGrow={1}
			>
				<HeaderLogo {...headerProps} />
				{headerProps && headerProps.customAttributes && headerProps.customAttributes.searchBox !== 'none'
					? (
						<Hidden xsDown>
							<HeaderSearchBox
								{...props}
								searchBy={headerProps
									&& headerProps.otherSettings
									&& headerProps.otherSettings.searchBox
									&& headerProps.otherSettings.searchBox.search_results
									? headerProps.otherSettings.searchBox.search_results
									: 'default'}
							/>
							{calendar !== 'none'
							&& (window.location.pathname === '/'
							|| window.location.pathname === '/search') && (
								<Hidden smDown>
									<Box classes={{ root: classes.selector }}>
										<p style={{
											width: '110px',
											margin: '0px',
											color: '#a6a6a6',
											fontSize: '1rem',
											fontWeight: 200,
											fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
										}}
										>
											<DateRange className={classes.icons} />
											Add Dates:
										</p>
										<DateRangeSelector
											callback={updateProducts}
											pageActiveCallback={pageActiveCallback}
											searchParams={searchParams}
											showTriggerButton={false}
											searchComponents={searchComponents}
											showcleardates
										/>
									</Box>
								</Hidden>
							)}
						</Hidden>
					) : null}
			</Box>
			<Box display="flex" alignItems="center" justifyContent="flex-end" flexGrow={1}>
				<Hidden xsDown>
					{headerProps && headerProps.otherSettings && headerProps.customAttributes.menu !== 'none'
						? (<HeaderMenu {...headerProps} />)
						: null}
					<SignUp mobileView={false} />
				</Hidden>
				<Hidden smUp>
					<FilterMain {...props} />
					{headerProps && headerProps.otherSettings && headerProps.customAttributes.searchBox !== 'none'
						&& (
							<HeaderSearchBox
								{...props}
								mobileView
								searchBy={
									headerProps
									&& headerProps.otherSettings
									&& headerProps.otherSettings.searchBox
									&& headerProps.otherSettings.searchBox.search_results
										? headerProps.otherSettings.searchBox.search_results
										: 'default'
								}
							/>
						)}
					<SideDrawer
						displayDivider={
							headerProps && headerProps.otherSettings && headerProps.customAttributes.menu
						}
					>
						<SignUp mobileView />
						{headerProps && headerProps.otherSettings && headerProps.customAttributes.menu !== 'none'
							&& <HeaderMenu {...headerProps} mobileView />}
					</SideDrawer>
				</Hidden>
			</Box>
		</Toolbar>
	);

	return (
		// eslint-disable-next-line no-nested-ternary
		headerProps && headerProps.customAttributes && headerProps.customAttributes.header !== 'none'
			? (
				<AppBar
					position="fixed"
					style={{ backgroundColor: 'white', boxShadow: 'none', zIndex: '1201' }}
				>
					<>
						{ width === 'xs'
						|| (headerProps
						&& headerProps.otherSettings
						&& headerProps.otherSettings.header
						&& headerProps.otherSettings.header.header_position === 'fixed')
							? <>{ navbar }</>
							: (
								<HideOnScroll {...props}>
									{navbar}
								</HideOnScroll>
							)}
						{(!layout || layout !== 'sidebar')
						&& (window.location.pathname === '/' || window.location.pathname === '/search')
						&& (
							<Hidden xsDown>
								<Toolbar
									style={{
										padding: '5px 40px',
										justifyContent: 'space-between',
										boxShadow: trigger || layout === 'map' || layout === 'default' || !layout
											? '0 3px 5px rgba(57, 63, 72, 0.3)'
											: 'none'
									}}
								>
									<FilterMain {...props} />
								</Toolbar>
							</Hidden>
						)}
					</>
				</AppBar>
			)
			: (!layout || layout !== 'sidebar')
			&& (window.location.pathname === '/' || window.location.pathname === '/search')
				? (
					<AppBar
						position="fixed"
						style={{
							backgroundColor: 'white',
							padding: '5px 40px',
							boxShadow: '0 3px 5px rgba(57, 63, 72, 0.3)',
							zIndex: '1201'
						}}
					>
						<Toolbar style={{ justifyContent: 'space-between' }}>
							<FilterMain {...props} />
						</Toolbar>
					</AppBar>
				)
				: null
	);
}

export default withWidth()(DefaultHeader);
